import { DOMHelper } from '../../Helpers/DOMHelper.js';
import { FormatHelper } from '../../Helpers/FormatHelper.js';

export class InputSlider {

	/**
	 * stepper config
	 * @param  FrontApp app      parent to access all other objects in the project
	 * @param  String elementId  dom element ID that shows up the popup on click
	 * @param  String inputName  dom element Name for submits
	 */
	constructor(app, elementId, inputName, min, max, useCurrencyFormat){
		this.app = app;				
		this.elementId = elementId;		
		this.inputName = inputName;		
		this.value = 0;		
		this.min = min;		
		this.min = min;		
		this.max = max;			
		this.step = "100.00";	
		this.useCurrencyFormat = useCurrencyFormat;		
		this.onChangeCallback = function(){};
		this.rootElement = document.querySelector(this.getSelector(''));		
	}


	addHtml(){	
		this.rootElement.classList.add('pmdrs-input-slider');			
		let content = `
			<input class="pmdrs-input-slider-txt" />
			<input type="range" name="`+ this.inputName+`" 
			class="mb-0 pmdrs-input-slider" 
			min="` + this.min + `" 
			max="` + this.max + `"
			step="` + this.step + `"
			value="0" >
		`;
		this.rootElement.innerHTML = content;				
	}

	/**
	 * Callback receiving value as parameters
	 * @param {[type]} onChangeCallback [description]
	 */
	setOnChange(onChangeCallback){
		this.onChangeCallback = onChangeCallback;
	}

	setValue(value){	
		value = FormatHelper.currencyToFloat(String(value));
		if(value < this.min){
			value = this.min;
		}else if(value > this.max){
			value = this.max;
		}
		let input = this.getInput();
		let txtInput = this.getTxtInput();
		input.value = value;
		if(this.useCurrencyFormat){
			txtInput.value = FormatHelper.currencyFormat(value,0);
		}else{
			txtInput.value = value;
		}
		this.value = value;
		return input.value;
	}

	getTxtInput(){
		return document.querySelector(this.getSelector('.pmdrs-input-slider-txt'));
	}

	getInput(){
		return document.querySelector(this.getSelector('.pmdrs-input-slider'));
	}

	getValue(){
		return this.value;
	}

	init() {
		this.addHtml();
		this.addHandlers();		
		this.setValue(this.min);
	}
	
	addHandlers(){
		let $this = this;
		var txtInputTimeoutId = 0;

		let onChange = function(event) {
			clearTimeout(txtInputTimeoutId);
			let value = event.target.value;
			value = $this.setValue(value);				
			$this.onChangeCallback(value);				

		}	

		let onInput = function(event) {
			$this.setValue(this.value);
		}
		DOMHelper.addHandler($this.getInput(), 'change', onChange);	
		DOMHelper.addHandler($this.getInput(), 'input', onInput);	


		//CASHDOWN CHANGE
		let txtInputTimeoutRefresh = function(){
			let inputElement = this;
			clearTimeout(txtInputTimeoutId);
			let delayOnChange = 1000;
            // Fire our onchange event                        
            txtInputTimeoutId = setTimeout(function() { 
            	DOMHelper.triggerEvent(inputElement,'change' ) 
            }, delayOnChange);
			
		}

		this.getTxtInput().addEventListener('input', txtInputTimeoutRefresh);
		this.getTxtInput().addEventListener('change', onChange);

		DOMHelper.setInputFilter(this.getTxtInput(), function(value) {
		  return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
		},
		value => {
			return value.replace(/[^\d*\.?\d*]+/g,"");
		});
	}

	getSelector(selector) {
		return this.app.getSelector("#"+this.elementId + " " + selector);
	}
}